import { getBookings } from "@/services/booking";

const state = {
  bookingList: null,
};

const getters = {
  bookings: (state) => state.bookingList,
};

const actions = {
  async getBookingList({ commit }) {
    try {
      const res = await getBookings();
      commit("getBookingList", res.data);
    } catch (error) {
      console.log(error);
    }
  },
  resetBookingList({ commit }) {
    commit("resetBookingList", null);
  }
};

const mutations = {
  getBookingList: (state, data) => (state.bookingList = data),
  resetBookingList: (state, data) => (state.bookingList = data),
};

export default { state, getters, actions, mutations };
